import React, { useState } from "react";
import axios from "axios";
import { TextField } from "@material-ui/core";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import DefaultButton from "../../../styles/materialButtonStyle";
import TwoFa from "../../../elements/twoFa/TwoFa";
import { useTranslation } from "react-i18next";

import { StyledBlockAction, StyledInputBlock } from "../../../styles/styledTabsForm";
import { check2FA } from "../../../../utils/check2FA";
import getUserInfo from "../../../../utils/getUserInfo";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const RangeFeeEditForm = ({ fee, notification, setNotification, url }) => {
  const { t } = useTranslation("clientsPage");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    percent: null,
    constant: null,
    min: null,
    max: null
  });

  const inputProps = {
    step: "any"
  };

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put(url + fee.id, submitData, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("details.rangeFee.edit.success") });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.rangeFee.edit.form.twoFa")}
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        className="fee-edit"
        onSubmit={event => {
          event.preventDefault();

          setSubmitData({
            ...setSubmitData,
            percent: event.target.percent.value,
            constant: event.target.constant.value,
            minAmount: event.target.minAmount.value,
          });
          setOpen(true);
        }}
      >
        <div className="fee-edit__items">
          <TextField
            className="grid-form__input"
            label={t("details.rangeFee.edit.form.basePercent")}
            type="text"
            value={Math.round((fee.baseFee.percent * 100) * 1000)/1000}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.rangeFee.edit.form.baseConstant")}
            type="text"
            value={fee.baseFee.constant}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.rangeFee.edit.form.minBaseFee")}
            type="text"
            value={fee.minAmount}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
        </div>
        <div className="fee-edit__items">
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.rangeFee.edit.form.percent")}
            id="percent"
            inputProps={inputProps}
            type="number"
            name="percent"
            defaultValue={Math.round((fee.cleanPercent * 100) * 1000)/1000}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.rangeFee.edit.form.constant")}
            id="constant"
            type="number"
            name="constant"
            defaultValue={fee.cleanConstant}
          />
          <TextField
            className="grid-form__input"
            variant="filled"
            label={t("details.rangeFee.edit.form.min")}
            id="minAmount"
            type="number"
            name="minAmount"
            defaultValue={fee.minAmount}
          />
        </div>
        <StyledBlockAction>
          <DefaultButton
            color="success"
            type="submit"
          >
            {t("details.rangeFee.edit.form.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default RangeFeeEditForm;